import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import SiteFooter from './components/SiteFooter';
import Dashboard from './pages/Dashboard';
import NewReview from './pages/NewReview';
import ReviewView from './pages/ReviewView';
import AnalysisProgress from './pages/AnalysisProgress';
import ResultsDashboard from './pages/ResultsDashboard';
import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new" element={<NewReview />} />
        <Route path="/reviews/:id" element={<ReviewView />} />
        <Route path="/reviews/:id/progress/:runId" element={<AnalysisProgress />} />
        <Route path="/reviews/:id/results" element={<ResultsDashboard />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}
